module.exports = __webpack_public_path__ + "static/img/member.4dff22c8.png";